module.exports = ".footer ul {\r\n    list-style: none;\r\n}\r\n\r\n.footer ul > li {\r\n    display: inline-block;\r\n    padding: 0 10px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/footer/footer.component.css
// module id = ./src/app/components/shared/footer/footer.component.css
// module chunks = main